import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { getDateFnsLocale } from "@tellescope/utils";
import { format } from "date-fns/format";

export const TodayButtonContents = () => {
  const todayDateRef = useRef(new Date());
  const { t, i18n } = useTranslation("calendar");
  const locale = getDateFnsLocale(i18n.language);
  return (
    <>
      <span className="text-[10px] font-medium leading-none text-muted-foreground uppercase tracking-wide">
        {format(todayDateRef.current, "MMM", { locale })}
      </span>
      <span className="font-bold text-[32px] leading-none">{todayDateRef.current.getDate()}</span>
      <span className="text-[10px] font-medium leading-none text-muted-foreground uppercase tracking-wide">
        {t("Today")}
      </span>
    </>
  );
};
